import React, { FC } from 'react'
import styles from 'styles/components/list.module.scss'
import { OrderBreadType } from 'types/bread'
import { OrderBreadListItem } from 'components/List'
import { findBreadShortName } from 'lib/helper'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getBreads } from 'reducks/bread/selectors'

type Props = {
  handleExpandedBreadIds: (id: string) => void
  orderBreads: OrderBreadType[]
}

const OrderBreadList: FC<Props> = (props) => {
  const { handleExpandedBreadIds, orderBreads } = props
  const breads = useSelector((state: State) => getBreads(state))

  return (
    <div className={styles.order}>
      <div className={styles.order__header}>
        <span className={styles.order__header__cell}>商品名</span>
        <span className={styles.order__header__cell}>個数(個)</span>
      </div>
      {orderBreads.map((orderBread, index) => {
        const pickupableTimes = orderBread.pickupable_times.sort((a, b) => {
          return a.pickupable_time < b.pickupable_time ? -1 : 1
        })
        const breadName = findBreadShortName(breads, orderBread.breadName, orderBread.breadRef)
        return (
          <OrderBreadListItem
            key={`${orderBread.breadRef.id}-${index}`}
            breadRef={orderBread.breadRef}
            breadName={breadName}
            handleExpandedBreadIds={handleExpandedBreadIds}
            manufacturerName={orderBread.manufacturerName}
            pickupableTimes={pickupableTimes}
            storeName={orderBread.storeName}
          />
        )
      })}
    </div>
  )
}

export default OrderBreadList
